import { rosterMatch } from '@api/api'
import { FlowCardLoading } from '@components/FlowCard'
import { FailedRosterMatch } from '@components/RouteComponents'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_initialized/verifyRosterMatch')({
  loader: async ({ context: { store }, location }) => {
    const state = store.getState().onboarding
    const actions = store.getActions().onboarding
    const orgId = state.orgId
    const firstName = state.firstName
    const lastName = state.lastName
    const email = state.email
    const redirectProps = {
      replace: true,
      search: location.search,
      throw: true,
    }

    let rosterMatchData
    try {
      rosterMatchData = await rosterMatch(orgId!, firstName, lastName, email)
    } catch {
      redirect({ to: '/email', ...redirectProps })
    }

    if (!rosterMatchData) return

    const {
      data: {
        data: { roster_match, already_linked },
      },
    } = rosterMatchData

    if (roster_match && !already_linked) {
      actions.setIsFinishingSignup(true)
    }

    if (roster_match) {
      if (already_linked) {
        redirect({
          to: '/phone/signInPhone',
          ...redirectProps,
          search: {
            ...redirectProps.search,
          },
        })
      } else {
        redirect({
          to: '/terms',
          ...redirectProps,
          search: {
            ...redirectProps.search,
            agreementType: 'user',
          },
        })
      }
    }
  },
  component: FailedRosterMatch,
  pendingComponent: FlowCardLoading,
  pendingMs: 0,
  gcTime: 0,
})
